var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleToggleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0H15C15.9193 -1.36979e-08 16.8295 0.18106 17.6788 0.532843C18.5281 0.884626 19.2997 1.40024 19.9497 2.05025C20.5998 2.70026 21.1154 3.47194 21.4672 4.32122C21.8189 5.17049 22 6.08075 22 7C22 7.91925 21.8189 8.8295 21.4672 9.67878C21.1154 10.5281 20.5998 11.2997 19.9497 11.9497C19.2997 12.5998 18.5281 13.1154 17.6788 13.4672C16.8295 13.8189 15.9193 14 15 14H7C6.08075 14 5.1705 13.8189 4.32122 13.4672C3.47194 13.1154 2.70026 12.5998 2.05025 11.9497C1.40024 11.2997 0.884626 10.5281 0.532843 9.67878C0.18106 8.8295 0 7.91925 0 7C0 6.08075 0.18106 5.17049 0.532843 4.32122C0.884626 3.47194 1.40024 2.70026 2.05025 2.05025C2.70026 1.40024 3.47194 0.884626 4.32122 0.532843C5.1705 0.18106 6.08075 -1.36979e-08 7 0ZM15 10C15.7956 10 16.5587 9.68393 17.1213 9.12132C17.6839 8.55871 18 7.79565 18 7C18 6.20435 17.6839 5.44129 17.1213 4.87868C16.5587 4.31607 15.7956 4 15 4C14.2044 4 13.4413 4.31607 12.8787 4.87868C12.3161 5.44129 12 6.20435 12 7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10Z",
    fill: "#AEB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleToggleButton);
export default __webpack_public_path__ + "static/media/purple-toggle-button.7c45e1400ed5a25ae1f4e3aa670c2741.svg";
export { ForwardRef as ReactComponent };